import React from "react";
import "../../loader.css";

const Loader = () => {
  return (
    <div className="my-auto h-full bg-gray-100 w-full absolute opacity-25">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
